var React = require('react');

function MorePoints (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"3","r":"3","fill":"#0088BF","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"3","fill":"#0088BF","key":1}),React.createElement("circle",{"cx":"12","cy":"21","r":"3","fill":"#0088BF","key":2})]);
}

MorePoints.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MorePoints;

MorePoints.default = MorePoints;
